"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var form_item_1 = __importDefault(require("../form-item"));
var react_intl_1 = require("react-intl");
var translationMessages = react_intl_1.defineMessages({
    baseInformation_accountingCostLabel: {
        id: "baseInformation_accountingCostLabel",
        defaultMessage: "Accounting cost"
    },
    baseInformation_accountingCostLabel_helpText: {
        id: "baseInformation_accountingCostLabel_helpText",
        defaultMessage: "Accounting cost is a code provided by the buyer, either via phone or e-mail or taken directly from the an order associated with the invoice"
    },
});
var AccountingCost = function (props) {
    var _a = react_1.useState(""), accountingCostHandlingValidationStatus = _a[0], setAccountingCostHandlingValidationStatus = _a[1];
    var _b = react_1.useState({}), accountingCostFieldProps = _b[0], setAccountingCostFieldProps = _b[1];
    var _c = react_1.useState(false), loadingAccountingCostValues = _c[0], setLoadingAccountingCostValues = _c[1];
    var accountingCostFieldDefinition = RequirementsUtility_1.getFieldRequirements(props.receiverRequirements, ReceiverRequirements_1.AvailableFields.accountingCost);
    if (accountingCostFieldDefinition) {
        return (react_1.default.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.accountingCost, defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_accountingCostLabel), defaultLabelTooltip: props.intl.formatMessage(translationMessages.baseInformation_accountingCostLabel_helpText), defaultIsRequired: false, fieldName: ["invoice", "accountingCost"], validateStatus: accountingCostHandlingValidationStatus, hasFeedback: true }, RequirementsUtility_1.getInput(accountingCostFieldDefinition, ["invoice", "accountingCost"], "handleAccountingCostValidation", props.legalIdentifier, props.formInstance, props.rapiBaseUrl, props.receiverRequirements, props.updateReceiverRequirementsProp, setAccountingCostFieldProps, accountingCostFieldProps, setLoadingAccountingCostValues, loadingAccountingCostValues, setAccountingCostHandlingValidationStatus)));
    }
    else {
        return null;
    }
};
exports.default = react_intl_1.injectIntl(AccountingCost);
